/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unavailable_TitleInputs */



/**
* | output |
* | --- |
* | "You use Wundo in Teams or Slack" |
*
* @param {Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const unavailable_title = /** @type {((inputs?: Unavailable_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unavailable_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo gebruik je in Teams of Slack")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous utilisez Wundo dans Teams ou Slack")
	return /** @type {LocalizedString} */ ("You use Wundo in Teams or Slack")
});